import gql from "graphql-tag";

import { OverviewAppSyncClient } from "../clients/OverviewAppSyncClient";
import { findBatchJobsByMonth } from "../../graphql/queries";
import { createAndProduceBatches } from "../../graphql/mutations";
import { LocalClearanceBatch, MonthOption, Exception } from "../Types";
import { OverviewHttpClient } from "../clients/OverviewHttpClient";
import { DateFormatter } from "../DateFormatter";

export class OverviewService {

    constructor(
        private overviewAppSyncClient: OverviewAppSyncClient,
        private overviewHttpClient: OverviewHttpClient
    ) {}

    async findBatchJobsByMonth({month, year}: MonthOption): Promise<any> {
        return this.overviewAppSyncClient.appSyncClient.query({
            query: gql(findBatchJobsByMonth),
            fetchPolicy: 'network-only',
            variables: {month, year}
        })
    }

    async createAndProduceBatches(batches : LocalClearanceBatch[]): Promise<any> {
        return this.overviewAppSyncClient.appSyncClient.mutate({
            mutation: gql(createAndProduceBatches), 
            variables: {
                dates: batches.map(x => x.day_bucket_date)
            }
        })
    }

    async retryExceptions(exceptions: Exception[]): Promise<void> {
      return await this.overviewHttpClient.request<void>('/api/exception/retry', undefined, { ids: exceptions.filter(e => e.id).map(e => e.id)});
    }

    async findExceptions(): Promise<Exception[]> {
        const exceptions = await this.overviewHttpClient.request<Exception[]>('/api/exception');

        return exceptions.map(exception => {
            const createdAt = DateFormatter.createFromISO(exception.createdAt)

            return {
                ...exception,
                momentOfLocalClearance: exception.momentOfLocalClearance?.substring(0, 10) || '',
                createdAt: DateFormatter.formatDate(createdAt, 'dd-MM-yyyy HH:mm'),
            }
        });
    }

}